import styled from "styled-components/macro";

export const CompanyTabsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  &.loading-wrapper {
    height: calc(100vh - 96px);
    justify-content: center;
  }

  .tabs-header {
    display: flex;
    align-items: center;
    border-bottom: 1px solid var(--Neutral-8);

    .tab-item {
      display: flex;
      padding: 10px 20px;
      justify-content: center;
      align-items: center;
      border-radius: 8px 8px 0 0;
      gap: 2px;
      cursor: pointer;
      height: 40px;

      svg {
        width: 16px;
        height: 16px;
      }

      &.active {
        border-bottom: 1px solid var(--Neutral-100);
        background: var(
          --White-96,
          linear-gradient(
            0deg,
            rgba(31, 31, 31, 0.04) 0%,
            rgba(31, 31, 31, 0.04) 100%
          ),
          #fff
        );

        svg {
          fill: var(--Neutral-100);
        }
      }

      &:hover {
        background: var(
          --White-96,
          linear-gradient(
            0deg,
            rgba(31, 31, 31, 0.04) 0%,
            rgba(31, 31, 31, 0.04) 100%
          ),
          #fff
        );
      }

      .tab-label {
        padding: 0 4px;
        color: var(--Neutral-100);
        font-size: 14px;
        font-weight: 500;
        line-height: 20px;
        letter-spacing: -0.021px;
      }
    }
  }

  .tab-content {
    height: calc(100vh - 224px);
  }

  .buttons-wrapper {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 8px;
    height: 40px;

    button {
      padding: 10px 20px;
    }
  }
`;

export const ButtonsWrapperStyles = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  height: 40px;

  button {
    padding: 10px 20px;
  }
`;

export const CompanyInfoStyles = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 24px;

  &.domains-view {
    height: calc(100vh - 97px);
  }

  &.loading-domains-view {
    justify-content: center;
  }

  .add-admin-button {
    display: flex;
    padding: 8px;
    align-items: center;
    gap: 6px;
    justify-content: center;
    color: var(--Brand-100);
    font-size: 12px;
    font-weight: 500;
    line-height: 16px;
    letter-spacing: -0.018px;
    width: 110px;
    cursor: pointer;
    border-radius: 24px;
    background: var(
      --Brand-4,
      linear-gradient(
        0deg,
        rgba(173, 66, 255, 0.04) 0%,
        rgba(173, 66, 255, 0.04) 100%
      ),
      #fff
    );

    svg {
      width: 14px;
      height: 14px;
    }
  }

  .edit-delete-icon {
    padding: 10px;
    display: flex;
    align-items: center;
    border-radius: 50%;
    cursor: pointer;

    &:hover {
      background: var(--Neutral-4);
    }

    svg {
      width: 20px;
      height: 20px;
    }
  }
  .company-form-wrapper {
    display: flex;
    align-items: stretch;
    gap: 24px;

    &.domain-list-wrapper {
      gap: 4px;
      flex-direction: column;
    }

    .domains-wrapper {
      max-width: 400px;
      width: 100%;
      display: flex;
      gap: 8px;
      align-items: flex-end;
    }

    /* Hide default focus/outline and change background on checked */
    .lead-email-title input[type="checkbox"] {
      appearance: none; /* remove default checkbox style */
      -webkit-appearance: none;
      width: 16px;
      height: 16px;
      border: 1px solid #ccc;
      border-radius: 3px;
      background-color: transparent; /* transparent background by default */
      position: relative;
      cursor: pointer;
      transition: all 0.2s ease;
    }

    .lead-email-title input[type="checkbox"]:checked {
      background-color: #1f1f1f; /* black background when checked */
    }

    .lead-email-title input[type="checkbox"]:focus {
      outline: none; /* remove default focus outline */
      box-shadow: none; /* remove default blue shadow */
    }

    /* Optional: add a checkmark */
    .lead-email-title input[type="checkbox"]:checked::after {
      content: "";
      position: absolute;
      top: 2px;
      left: 5px;
      width: 4px;
      height: 8px;
      border: solid white;
      border-width: 0 2px 2px 0;
      transform: rotate(45deg);
    }

    .lead-email-title {
      display: flex;
      align-items: center;
      gap: 8px;
      color: var(--Neutral-100);
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      letter-spacing: -0.014px;
    }

    .radio-group {
      display: flex;
      flex-direction: column;
      gap: 4px;

      .radio-option {
        display: flex;
        align-items: center;
        width: fit-content;
        cursor: pointer;
        gap: 6px;

        .outer-circle {
          width: 16px;
          height: 16px;
          border: 2px solid #333;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;

          .inner-circle {
            width: 8px;
            height: 8px;
            background-color: #333;
            border-radius: 50%;
          }

          &.selected {
            background: 2px solid #1f1f1f;
          }
        }
        .option-label {
          color: var(--Neutral-80);
          font-size: 14px;
          font-weight: 400;
          line-height: 20px;
          letter-spacing: -0.014px;
        }
      }
    }

    .input-wrappers {
      display: flex;
      flex-direction: column;
      gap: 16px;
      width: 50%;
      /* flex: 1; */

      &.company-logo {
        flex-direction: row;
        align-items: flex-end;
        flex-wrap: nowrap;
        gap: 6px;

        button {
          flex-shrink: 0;
          border-radius: 12px;
        }
      }
    }

    .text-area-wrapper {
      display: flex;
      flex-direction: column;
      width: 50%;
      flex: 1;
    }

    textarea {
      height: 100%;
    }

    .textarea-wrapper {
      flex: 1;
      display: flex;
      flex-direction: column;
    }
  }
`;
